import {Disposable, Environment, commitMutation, graphql} from 'react-relay';
import Util from '../../../forecast-app/shared/util/util';
import {
	MissionControlDeactivateSageIntacctInput,
	MissionControlDeactivateSageIntacctMutation,
} from './__generated__/MissionControlDeactivateSageIntacctMutation.graphql';
import RelayEnvironment from '../../../RelayEnvironment';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../../ts/MutationTypes';

const mutation = graphql`
	mutation MissionControlDeactivateSageIntacctMutation($input: MissionControlDeactivateSageIntacctInput!) {
		missionControlDeactivateSageIntacct(input: $input) {
			outcome
			errorMessage
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<MissionControlDeactivateSageIntacctInput>,
	onSuccess: RelayOnCompleted<MissionControlDeactivateSageIntacctMutation>,
	onError: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation(RelayEnvironment.getInstanceMC(), {
		mutation,
		variables,
		configs: [],
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
